/**
 * External dependencies
 */
import styled from '@emotion/styled';

/**
 * WordPress dependencies
 */
import { Icon } from '@wordpress/icons';

export const StyledIcon = styled( Icon )`
	width: 1.4em;
	height: 1.4em;
	margin: -0.2em 0.1em 0;
	vertical-align: middle;
	fill: currentColor;
`;
